import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgIconVersionsLayers = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M10.6645 2.88397C11.495 2.42255 12.5049 2.42255 13.3355 2.88397L19.476 6.29538C20.8134 7.03834 20.8134 8.96163 19.476 9.70459L13.3355 13.116C12.5049 13.5774 11.495 13.5774 10.6645 13.116L4.52393 9.70459C3.1866 8.96163 3.1866 7.03834 4.52393 6.29538L10.6645 2.88397ZM12.607 4.19521C12.2295 3.98547 11.7705 3.98547 11.3929 4.19521L5.2524 7.60661C4.94378 7.77807 4.94378 8.2219 5.2524 8.39336L11.3929 11.8048C11.7705 12.0145 12.2295 12.0145 12.607 11.8048L18.7476 8.39336C19.0562 8.2219 19.0562 7.77807 18.7476 7.60661L12.607 4.19521Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M4.27092 15.25C4.68513 15.25 5.02093 15.5858 5.02094 16C5.02094 16.1594 5.09731 16.3072 5.2524 16.3933L11.3929 19.8048C11.7705 20.0145 12.2295 20.0145 12.607 19.8048L18.7476 16.3933C18.9027 16.3072 18.979 16.1594 18.979 16C18.979 15.5858 19.3148 15.25 19.729 15.25C20.1433 15.25 20.479 15.5858 20.479 16C20.479 16.661 20.1439 17.3335 19.476 17.7046L13.3355 21.116C12.5049 21.5774 11.495 21.5774 10.6645 21.116L4.52393 17.7046C3.85606 17.3335 3.52095 16.661 3.52094 16C3.52093 15.5858 3.85671 15.25 4.27092 15.25Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M5.02094 12C5.02093 11.5858 4.68513 11.25 4.27092 11.25C3.85671 11.25 3.52093 11.5858 3.52094 12C3.52095 12.661 3.85606 13.3335 4.52393 13.7046L10.6645 17.116C11.495 17.5774 12.5049 17.5774 13.3355 17.116L19.476 13.7046C20.1439 13.3335 20.479 12.661 20.479 12C20.479 11.5858 20.1433 11.25 19.729 11.25C19.3148 11.25 18.979 11.5858 18.979 12C18.979 12.1594 18.9027 12.3072 18.7476 12.3933L12.607 15.8048C12.2295 16.0145 11.7705 16.0145 11.3929 15.8048L5.2524 12.3933C5.09731 12.3072 5.02094 12.1594 5.02094 12Z",
			fill: "currentColor"
		})
	]
});
export { SvgIconVersionsLayers as ReactComponent };
